export default {
  label: {
    notes: 'Label of hide signals action for visualisation',
    message: 'Hide all signals',
  },
};
